var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "period",
                      type: "date-range-picker",
                      label: _vm.$t("Período"),
                      "time-picker": false,
                    },
                    model: {
                      value: _vm.filters.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "period", $$v)
                      },
                      expression: "filters.period",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      multiple: true,
                      required: false,
                      "select-single-option": false,
                      label: _vm.$t("Lojas"),
                      placeholder: _vm.$t("Todas"),
                    },
                    model: {
                      value: _vm.filters.storeIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeIds", $$v)
                      },
                      expression: "filters.storeIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "days-of-week",
                      type: "vue-select",
                      multiple: true,
                      label: _vm.$t("Dias da semana"),
                      placeholder: _vm.$t("Todos"),
                      options: _vm.stockCountingDayOfWeekOptions(),
                    },
                    model: {
                      value: _vm.filters.daysOfWeek,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "daysOfWeek", $$v)
                      },
                      expression: "filters.daysOfWeek",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "group-id",
                      type: "vue-select",
                      label: _vm.$t("Grupo"),
                      placeholder: _vm.$t("Todos"),
                      options: _vm.getComboGroups,
                    },
                    model: {
                      value: _vm.filters.groupId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "groupId", $$v)
                      },
                      expression: "filters.groupId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "brand-id",
                      type: "vue-select",
                      label: _vm.$t("Marca"),
                      placeholder: _vm.$t("Todas"),
                      options: _vm.getComboBrands,
                    },
                    model: {
                      value: _vm.filters.brandId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "brandId", $$v)
                      },
                      expression: "filters.brandId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "min-divergent-skus-percent",
                      type: "text-number",
                      precision: 2,
                      label: _vm.$t("% mín. SKUs divergentes"),
                    },
                    model: {
                      value: _vm.filters.minDivergentSkusPercent,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "minDivergentSkusPercent", $$v)
                      },
                      expression: "filters.minDivergentSkusPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "only-non-compliant",
                      type: "switch",
                      label: _vm.$t("Somente não conformes"),
                    },
                    model: {
                      value: _vm.filters.onlyNonCompliant,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "onlyNonCompliant", $$v)
                      },
                      expression: "filters.onlyNonCompliant",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "only-with-divergence",
                      type: "switch",
                      label: _vm.$t("Somente com divergência"),
                    },
                    model: {
                      value: _vm.filters.onlyWithDivergence,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "onlyWithDivergence", $$v)
                      },
                      expression: "filters.onlyWithDivergence",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.summary
        ? _c(
            "b-row",
            _vm._l(_vm.summaryCards, function (card) {
              return _c(
                "b-col",
                { key: card.title, attrs: { md: "2", sm: "6" } },
                [
                  _c("statistic-card-horizontal", {
                    attrs: {
                      icon: card.icon,
                      color: card.color,
                      statistic: card.value,
                      "statistic-title": card.title,
                    },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.summary && _vm.summary.evaluatedUntil
        ? _c(
            "b-alert",
            { staticClass: "p-1", attrs: { show: "", variant: "light" } },
            [
              _c("small", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "Aderência avaliada até {date}. O dia corrente não entra no cálculo porque as lojas ainda podem realizar a contagem.",
                        {
                          date: _vm.$options.filters.date(
                            _vm.summary.evaluatedUntil
                          ),
                        }
                      )
                    ) +
                    " "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.activePaging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Aderência às regras") } },
                [
                  _c("stock-counting-compliance-table", {
                    staticClass: "mt-1",
                    attrs: {
                      items: _vm.compliance,
                      paging: _vm.compliancePaging,
                      "query-executed": _vm.queryExecuted,
                    },
                    on: { "page-change": _vm.compliancePageChange },
                  }),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("Divergências") } },
                [
                  _c("stock-counting-divergence-table", {
                    staticClass: "mt-1",
                    attrs: {
                      items: _vm.divergences,
                      paging: _vm.divergencePaging,
                      "query-executed": _vm.queryExecuted,
                    },
                    on: {
                      "page-change": _vm.divergencePageChange,
                      "read-only": _vm.showCounting,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }